import { useEffect, useState } from "react";

// En un dispositivo táctil no hay puntero que pueda quedarse encima de un elemento
const NO_HOVER_QUERY = "(hover: none)";

const matchesNoHover = () => window.matchMedia?.(NO_HOVER_QUERY)?.matches ?? false;

/**
 * Indica si la última interacción vino de un dedo, para poder abrir los submenús por
 * toque en vez de por hover. Arranca con lo que dice el medio y a partir de ahí manda el
 * último puntero usado, porque en equipos híbridos (portátil táctil, tablet con ratón) la
 * media query sola no acierta.
 *
 * @returns {boolean} true si se está navegando a dedo
 */
const useIsTouchInput = () => {
  const [isTouchInput, setIsTouchInput] = useState(matchesNoHover);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (event.pointerType === "touch") {
        setIsTouchInput(true);
      } else if (event.pointerType === "mouse") {
        setIsTouchInput(false);
      }
    };

    // En captura para enterarnos aunque el elemento tocado pare la propagación
    window.addEventListener("pointerdown", handlePointerDown, true);
    return () => window.removeEventListener("pointerdown", handlePointerDown, true);
  }, []);

  return isTouchInput;
};

export default useIsTouchInput;
